import css from 'styled-jsx/css';

export const styles = css`
  .Truncate__content {
    margin: 0 0 10px;
  }
`;
